/**
 * Whether a payment method starts switched on when a checkout step gets its
 * first payment config. Slash takes real money with no test mode: a page gets
 * it switched off and the merchant turns it on (#TAG-2955), the same rule the
 * funnel save applies.
 */
const OFF_UNTIL_SWITCHED_ON = new Set(['slash']);

export function startsEnabled(provider: string | undefined): boolean {
  return provider === undefined || !OFF_UNTIL_SWITCHED_ON.has(provider);
}
